import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractLabelComponent } from './components/label/contract-label/contract-label.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ContractPipe } from './pipes/contract.pipe';
import { SelectContractDialogComponent } from './components/dialog/select-contract-dialog/select-contract-dialog.component';
import { ContractPreviewComponent } from './components/preview/contract-preview/contract-preview.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ContractTableComponent } from './components/embedded/contract-table/contract-table.component';
import { ContractTypePipe } from './pipes/contract-type.pipe';
import { ContractStatusPipe } from './pipes/contract-status.pipe';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SharedModule } from '../shared/shared.module';
import { ContractDetailViewComponent } from './components/main/contract-detail-view/contract-detail-view.component';
import { ContractFormComponent } from './components/embedded/contract-form/contract-form.component';
import { QuillModule } from 'ngx-quill';
import { SelectContractTypeComponent } from './components/select/select-contract-type/select-contract-type.component';
import { SelectContractStatusComponent } from './components/select/select-contract-status/select-contract-status.component';
import { ContractItemsFormComponent } from './components/embedded/contract-items-form/contract-items-form.component';
import { ProductModule } from '../product/product.module';
import { CreateContractDialogComponent } from './components/dialog/create-contract-dialog/create-contract-dialog.component';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  declarations: [
    ContractLabelComponent,
    ContractPipe,
    SelectContractDialogComponent,
    ContractPreviewComponent,
    ContractTableComponent,
    ContractTypePipe,
    ContractStatusPipe,
    ContractDetailViewComponent,
    ContractFormComponent,
    SelectContractTypeComponent,
    SelectContractStatusComponent,
    ContractItemsFormComponent,
    CreateContractDialogComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatToolbarModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FormsModule,
    MatSortModule,
    MatTableModule,
    ProductModule,
    SharedModule,
    ReactiveFormsModule,
    QuillModule.forRoot()
  ],
  exports: [
    ContractPipe,
    ContractLabelComponent,
    ContractPreviewComponent,
    ContractTableComponent,
    ContractDetailViewComponent
  ]
})
export class ContractModule { }
